import { createContext, useContext, useMemo } from "react";
import { IHolidayService } from "../services/HolidayService";
import { useHttpRequestService } from "./HttpRequestContext";
import { createHolidayService } from "./Bootstrap";

const HolidayContext = createContext<IHolidayService | null>(null);

export const HolidayProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const holidayService = useMemo(() => createHolidayService(httpRequestService), [httpRequestService]);
    return (
        <HolidayContext.Provider value={holidayService}>
            {children}
        </HolidayContext.Provider>
    );
}

export const useHolidayService = () => {
    const holidayService = useContext(HolidayContext);
    if (!holidayService) {
        throw new Error('useHolidayService must be used within a HolidayProvider');
    }
    return holidayService;
};
